var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms4HealthLogoMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303.84 57.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dde6fd;}.cls-2{fill:#00c8ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    className: "cls-1",
    d: "M81,17.06a5.91,5.91,0,0,0-2.23-.44c-1.91,0-3.25.84-3.25,3.65v1.3H80v4h-4.5V44.16H70.19V25.58h-3.3v-4h3.3V20.22a7.33,7.33,0,0,1,6.54-8,7.6,7.6,0,0,1,1.35,0,10.13,10.13,0,0,1,2.94.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    className: "cls-1",
    d: "M81.06,33.12c0-6.74,4.19-11.9,10.88-11.9,7.22,0,10.92,5.17,10.92,11.58,0,6.6-3.84,11.72-10.92,11.72S81.06,39.48,81.06,33.12Zm5.62-.18c0,3.92,1.78,7.31,5.3,7.31S97.29,37,97.29,33s-1.43-7.4-5.35-7.4c-3.57,0-5.26,3.38-5.26,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    className: "cls-1",
    d: "M111.46,25.57a6.29,6.29,0,0,1,7.22-4.05v5.17a5.2,5.2,0,0,0-2.27-.44c-3,0-5,2.71-5,6.24V44.16h-5.39l.05-22.59h5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    className: "cls-1",
    d: "M127.2,25.13a6.83,6.83,0,0,1,6.37-3.83A6.2,6.2,0,0,1,140,25.58a7.08,7.08,0,0,1,6.73-4.28c4.58,0,7.18,2.9,7.18,8V44.16h-5.39V30.3c0-2.85-1.16-4.54-3.48-4.54-1.88,0-4.46,1.47-4.46,6.28V44.16h-5.38V30.3c0-2.85-1.16-4.55-3.48-4.55-1.92,0-4.5,1.47-4.5,6.29V44.16h-5.35V21.56h5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    className: "cls-1",
    d: "M170.52,27A11.38,11.38,0,0,0,165,25.66c-1.87,0-2.94.89-2.94,2.13,0,1.74,2.27,2.46,4.63,3.57,2.54,1.25,5.12,2.9,5.12,6.28,0,4.31-3.38,6.74-8.33,6.74A15.66,15.66,0,0,1,156.65,43V38.09a12.15,12.15,0,0,0,6.47,2c2,0,3.12-.81,3.12-2.09,0-1.79-2.23-2.54-4.77-3.61A7,7,0,0,1,156.52,28c0-4.33,3.74-6.69,8.29-6.69a15.58,15.58,0,0,1,5.7,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    className: "cls-2",
    d: "M195.84,36.85h-4.5v7.31h-2.67V36.85H175.16V34.4L186.84,15h4.5V34.4h4.5Zm-7.17-2.45V16.57L178,34.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    className: "cls-2",
    d: "M201.72,25.44a7.43,7.43,0,0,1,7.18-4.23,6.78,6.78,0,0,1,7.17,6.37,5.34,5.34,0,0,1,0,.8V44.16h-2.72V29.23a4.75,4.75,0,0,0-4.06-5.34,4.19,4.19,0,0,0-.79,0,7.1,7.1,0,0,0-6.81,7.38c0,.15,0,.31,0,.46V44.17H199V12.38h2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    className: "cls-2",
    d: "M237.42,43.06a15.62,15.62,0,0,1-6.24,1.34,10.78,10.78,0,0,1-11.32-10.2,9.79,9.79,0,0,1,0-1.21c0-7.35,4.14-11.68,9.94-11.68,5.38,0,9,3.66,9,10.39a17.64,17.64,0,0,1-.17,2.41h-16a7.83,7.83,0,0,0,7.9,7.75l.7,0a12.29,12.29,0,0,0,6.11-1.52ZM236,30.58a6.1,6.1,0,0,0-5.44-6.71,6.62,6.62,0,0,0-.89,0c-3.66,0-6.55,2.63-7,7.76H236Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    className: "cls-2",
    d: "M243.53,22.77a13.57,13.57,0,0,1,6.37-1.56c6,0,8.29,3.25,8.29,8.69V44.16h-2.72V41.53A7.34,7.34,0,0,1,249,44.38a6.57,6.57,0,0,1-7.07-6c0-.19,0-.37,0-.55,0-4.41,3.75-6.87,9.18-6.87h4.42v-1c0-3.83-1.39-6.11-5.62-6.11a12.14,12.14,0,0,0-6.33,1.92Zm7.54,10.65c-4.5,0-6.29,2-6.29,4.28s1.56,4.19,4.82,4.19a5.3,5.3,0,0,0,5.85-4.7,4.41,4.41,0,0,0,0-.52V33.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    className: "cls-2",
    d: "M263.53,12.38h2.72V44.17h-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    className: "cls-2",
    d: "M276.06,37.92c0,2.5,1.08,3.88,3.61,3.88a5.08,5.08,0,0,0,3-1v2.77a6.61,6.61,0,0,1-3,.84c-4.58,0-6.42-2.45-6.42-6.59V23.88h-3.7V21.56h3.7V15.91h2.76v5.65h6.47v2.32h-6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    className: "cls-2",
    d: "M289.48,25.44a7.43,7.43,0,0,1,7.18-4.23,6.78,6.78,0,0,1,7.17,6.37,5.34,5.34,0,0,1,0,.8V44.16h-2.72V29.23a4.73,4.73,0,0,0-4.06-5.34,4.14,4.14,0,0,0-.79,0,7.09,7.09,0,0,0-6.8,7.38,3.55,3.55,0,0,0,0,.46V44.17h-2.72V12.38h2.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    className: "cls-2",
    d: "M57.05,1.12v32a1.14,1.14,0,0,1-1.14,1.14H46.79a1.14,1.14,0,0,1-1.14-1.14h0V12.54a1.14,1.14,0,0,0-1.14-1.14H35.39a1.14,1.14,0,0,0-1.14,1.14v9.11a1.14,1.14,0,0,1-1.14,1.14H24a1.14,1.14,0,0,1-1.14-1.14V12.54a1.14,1.14,0,0,0-1.14-1.14H1.18A1.14,1.14,0,0,1,0,10.26V1.14A1.14,1.14,0,0,1,1.18,0H55.94A1.15,1.15,0,0,1,57.05,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    className: "cls-2",
    d: "M57.05,46.76v9.12A1.14,1.14,0,0,1,55.91,57H1.14A1.14,1.14,0,0,1,0,55.88V23.94A1.14,1.14,0,0,1,1.14,22.8h9.12a1.14,1.14,0,0,1,1.14,1.14V44.48a1.14,1.14,0,0,0,1.14,1.14h9.11a1.14,1.14,0,0,0,1.14-1.14V35.36a1.14,1.14,0,0,1,1.14-1.14h9.12a1.14,1.14,0,0,1,1.14,1.14v9.12a1.14,1.14,0,0,0,1.14,1.14H55.87a1.14,1.14,0,0,1,1.18,1.1Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms4HealthLogoMain);
export default __webpack_public_path__ + "static/media/Forms4Health_Logo_Main.324b3af9f5bbe8ae7b52d6e1a7390b4c.svg";
export { ForwardRef as ReactComponent };